import _ from 'lodash';

export function findComponent(componentId, array) {
	let el;
	for (var i = 0; i < array.length; i++) {
		if (componentId == array[i].componentId) {
			el = array[i];
			break;
		}
		if (array[i].childrenComponents && array[i].childrenComponents.length) {
			el = findComponent(componentId, array[i].childrenComponents);
			if (el) {
				break;
			} else {
				continue;
			}
		}
	}
	return el;
}

export function recalculateIndexes(page) {
	if (page.pageType != 'search') return;
	let desktopIndex = -1;
	let mobileIndex = -1;
	page.pageData.forEach((el) => {
		desktopIndex +=
			el.moveTo == 'desktop' ? 1 : el.componentGroup.includes('Desktop') ? el.childrenComponents.length : 0;
		mobileIndex += el.moveTo == 'mobile' ? 1 : el.componentGroup.includes('Mobile') ? el.childrenComponents.length : 0;
		el.moveIndex = el.moveTo == 'desktop' ? desktopIndex : mobileIndex;
	});
}

export function findCompByIdRecursively(array, componentId) {
	if (!array?.length) return { comp: null, parentArray: null };
	let foundComponent;
	let parentArr;

	for (var i = 0; i < array.length; i++) {
		const thisComp = array[i];

		if (thisComp?.pageData) {
			const { comp, parentArray } = findCompByIdRecursively(thisComp.pageData, componentId);
			if (comp) {
				foundComponent = comp.comp;
				parentArr = parentArray || [];
				break;
			}
		} else {
			if (thisComp?.componentId == componentId) {
				foundComponent = thisComp;
				parentArr = array;
				break;
			} else {
				if (thisComp?.childrenComponents?.length) {
					const { comp, parentArray } = findCompByIdRecursively(thisComp.childrenComponents, componentId);
					if (comp && parentArray) {
						foundComponent = comp;
						parentArr = parentArray;
						break;
					}
				}
				if (thisComp?.blocks?.length) {
					const { comp, parentArray } = findCompByIdRecursively(thisComp.blocks, componentId);
					if (comp && parentArray) {
						foundComponent = comp;
						parentArr = parentArray;
						break;
					}
				}
				//Buscando por Slots
				if (thisComp?.props) {
					const specialComponents = Object.keys(thisComp.props)
						.filter((el) => firstIsUppercase(el))
						.map((key) => thisComp.props[key]);
					const { comp, parentArray } = findCompByIdRecursively(specialComponents, componentId);
					if (comp && parentArray) {
						foundComponent = comp;
						parentArr = parentArray;
						break;
					}
				}
			}
		}
	}
	return { comp: foundComponent, parentArray: parentArr };
}

export function firstIsUppercase(str) {
	if (typeof str !== 'string' || str.length === 0) {
		return false;
	}

	if (str[0].toUpperCase() === str[0]) {
		return true;
	}

	return false;
}

export function useCssHandles(base, names, blockClass) {
	const obj = {
		handles: generateHandles(base, names, blockClass),
		withModifiers: withModifiers,
	};

	function generateHandles(base, names, blockClass, modifier) {
		const bufferObj = {};
		names = Array.isArray(names) ? names : [names];
		names.forEach((name) => {
			const buffer = `${name} ${base}-${name}${modifier ? ` ${name}--${modifier} ${base}-${name}--${modifier}` : ''}`;
			let bc;
			if (blockClass) bc = Array.isArray(blockClass) ? blockClass : [blockClass];
			if (!bc) return (bufferObj[name] = buffer);
			bufferObj[name] = bc.reduce(
				(acc, curr) =>
					acc +
					`${name} ${name}--${curr}${modifier ? `--${modifier}` : ''} ${base}-${name}${modifier ? `--${modifier}` : ''} ${base}-${name}--${curr}${modifier ? ` ${name}--${curr}--${modifier} ${base}-${name}--${curr}--${modifier}` : ''}`,
				'',
			);
		});
		return bufferObj;
	}
	//nao sei se tem lugar q usa mais de um modifier, e nao sei o que acontece neste caso
	function withModifiers(names, modifier) {
		const mdf = Array.isArray(modifier) ? modifier[0] : modifier;
		return generateHandles(base, names, blockClass, mdf)[names];
	}

	return obj;
}

//merge cssvariables
export function mergeVariables(defaultVariables, componentVariables) {
	if (!defaultVariables?.length) return [];
	if (!componentVariables?.length) return defaultVariables;
	return defaultVariables.map((dftVar) => {
		const cmpVar = componentVariables.find((el) => el.type == dftVar.type);
		if (!cmpVar) return dftVar;
		const dftObj = {};
		dftVar.list.forEach((el) => {
			dftObj[el.to] = { ...el };
		});

		cmpVar.list.forEach((el) => {
			if (dftObj[el.to]) {
				dftObj[el.to].name = el.name;
				dftObj[el.to].from = el.from;
			}
		});

		return {
			type: dftVar.type,
			list: Object.keys(dftObj).map((key) => dftObj[key]),
		};
	});
}
//merge component with default component
export function mergeComponentWithDefault(defaultComponent, comp) {
	if (!comp) return defaultComponent;
	const component = _.cloneDeep(comp);
	//mergindo props
	if (component.props || defaultComponent.componentName == component.componentName) {
		const mergedProps = defaultComponent?.props;
		if (!mergedProps) return defaultComponent;
		Object.keys(mergedProps).map((prop) => {
			if (typeof component.props[prop] !== 'undefined') {
				mergedProps[prop] = component.props[prop];
			}
		});
		component.props = mergedProps;
	} else {
		component.props = defaultComponent.props;
	}

	if (!defaultComponent?.childrenComponents) {
		component.childrenComponents = [];
	} else if (component?.childrenComponents?.length) {
		//procurando componentes equivalentes no defaultComponents e components
		//se houver adição ou remoção no defaultComponent poderá haver inconsistência
		const list = _.cloneDeep(component.childrenComponents);
		//limpando childComp
		component.childrenComponents = [];

		defaultComponent.childrenComponents.forEach((childComp, index) => {
			component.childrenComponents.push(searchComponent(childComp, list));
		});
	} else {
		component.childrenComponents = defaultComponent?.childrenComponents ?? [];
	}

	if (component?.componentGroup && defaultComponent?.componentGroup)
		component.componentGroup = defaultComponent.componentGroup;

	component.componentName = defaultComponent.componentName;
	return component;
}

//procura componentes equivalentes no defaultComponents e components
export function searchComponent(childComp, componentList) {
	const foundCompIndex = componentList.findIndex(
		(compListChild) => compListChild.componentName == childComp.componentName,
	);
	if (foundCompIndex < 0) return childComp;
	const foundComp = componentList[foundCompIndex];
	componentList.splice(foundCompIndex, 1);
	return mergeComponentWithDefault(childComp, foundComp);
}

export function filterByMobileState(element, selectedCanvasResolution) {
	const validComponents = [
		'HeaderDesktop',
		'FooterDesktop',
		'FooterMobile',
		'HeaderMobile',
		'StoreMenuDesktop',
		'StoreMenuMobile',
		'SearchResultLayoutDesktop',
		'SearchResultLayoutMobile',
	];
	const componentGroup = element.componentGroup;

	//if componentGroup is in validComponents array and componentGroup correspond to resolution return true
	if (validComponents.includes(componentGroup)) {
		if (selectedCanvasResolution > 1024 && componentGroup.toLowerCase().includes('desktop')) {
			return true;
		}
		if (selectedCanvasResolution <= 1024 && componentGroup.toLowerCase().includes('mobile')) {
			return true;
		}
		return false;
	}

	//check if element has moveto prop and return true if it contains word desktop or mobile and selectedCanvasResolution is greater than 1024 or less than 1024
	if (element.moveTo) {
		if (selectedCanvasResolution > 1024 && element.moveTo.toLowerCase().includes('desktop')) {
			return true;
		}
		if (selectedCanvasResolution <= 1024 && element.moveTo.toLowerCase().includes('mobile')) {
			return true;
		}
		return false;
	}

	return true;
}

export function fixIndexes(page, deletedIndex, moveTo) {
	if (page.pageType == 'search') {
		page.pageData.forEach((el, index) => {
			if (index < deletedIndex) return;
			if (el.moveTo == moveTo) {
				el.moveIndex = el.moveIndex - 1;
			}
		});
	}
}

export const specialComponents = {
	ProductSummaryShelf: 'shelf-1',
	MinicartGroup: 'minicart-1',
	BreadcrumbGroup: 'breadcrumb-1',
	StoreMenuDesktop: 'menu-1',
	StoreMenuMobile: 'menu-1',
};
